import { hasValue, isNullOrUndefined } from '@r-and-a-shared-ui/utils';
import { useFormContext } from 'react-hook-form';
import styles from '../FormTextPreview.ts/FormTextPreview.module.scss';
import { FormFieldPreviewProps } from '../FormFieldPreview/FormFieldPreview';

export const FormDropdownPreview = (props: FormFieldPreviewProps) => {
  const { name, label, hideLabel, options } = props;
  const { watch } = useFormContext();

  const value = watch(name);

  const toDisplayValue = (val: any): string | null => {
    if (!hasValue(val)) {
      return null;
    }

    if (typeof val === 'object') {
      return val?.name || val?.id || null;
    }

    return val.toString();
  };

  const getLabelForValue = (val: any) => {
    if (!hasValue(val)) {
      return null;
    }

    if (isNullOrUndefined(options)) {
      return toDisplayValue(val);
    }

    const option = options.find(
      opt => opt?.value === val?.id || opt?.value === val.toString(),
    );

    return option ? option.label : toDisplayValue(val);
  };

  return (
    <div className={styles.cell}>
      {!hideLabel && hasValue(label) && (
        <label className={styles.label}>{label}</label>
      )}
      {hasValue(value) && (
        <div className={styles.value}>{getLabelForValue(value)}</div>
      )}
    </div>
  );
};

export default FormDropdownPreview;
